import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaCardDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-rt-rest-ajax',
	templateUrl:'./RestAndAjaxPage.html',
	styles: [],
	styleUrls:['./RestAndAjaxPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
		WaCardDirective,
],
	standalone:true
})
export class RestAndAjaxPage
{
	mdContent_1178 = `Define a Java class, annotate it with \`@NgRestClient\`, and the framework generates a fully typed Angular service backed by \`HttpClient\` and Angular signals. One annotation per endpoint — GET, POST, PUT, DELETE, or PATCH — with built-in polling, caching, deduplication, retry, deep-merge, and authentication. No handwritten TypeScript. No boilerplate fetch calls.`;
	mdContent_1179 = `\`\`\`java
@NgRestClient(url = "/api/users")
public class UsersClient
        implements INgRestClient<UsersClient> {
}
\`\`\``;
	mdContent_1180 = `\`\`\`java
@NgRestClient(
    url = "/api/orders",
    method = NgRestClient.HttpMethod.POST,
    singleton = true,
    cachingEnabled = true,
    cacheTtlMs = 45_000,
    deduplication = true,
    retryCount = 3,
    retryDelayMs = 2_000
)
public class OrderClient
        implements INgRestClient<OrderClient> {
}
\`\`\``;
	mdContent_1181 = `\`\`\`java
@NgRestClient(
    url = "/api/notifications",
    responseArray = true,
    pollingEnabled = true,
    pollingIntervalMs = 10_000,
    deepMerge = true,
    fetchOnCreate = true
)
public class NotificationsClient
        implements INgRestClient<NotificationsClient> {
}
\`\`\``;
	mdContent_1182 = `\`\`\`java
@NgRestClient(
    url = "/api/combined",
    method = NgRestClient.HttpMethod.POST,
    authType = NgRestClient.AuthType.BEARER,
    authTokenField = "this.authService.token()"
)
@NgRestClientHeader(name = "Content-Type",
                    value = "application/json")
@NgRestClientQueryParam(name = "tenant",
                        value = "default")
public class CombinedClient
        implements INgRestClient<CombinedClient> {
}
\`\`\``;
}
